import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.views.ContactPicker.';
  public static readonly selectContact = `${Id.prefix}selectContact`;
  public static readonly close = `${Id.prefix}close`;
}

export class LangContactPicker {
  private constructor() {}
  public static selectContact(): string {
    return interpolate(Id.selectContact);
  }
  public static close(): string {
    return interpolate(Id.close);
  }
}

export class ContactPickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.selectContact, "Select a {{glossary 'contact'}}", 'Dialog title for selecting a contact');
    register.add(Id.close, 'Close', 'Button label for closing the dialog');
  }
}
